import FetchWrapper from "./FetchWrapper";

export const GetHolidays = () => {
  return fetchApi("/holidays")
}

export const GenerateHolidays = () => {
  return fetchApi('/holidays/generate', { method: 'POST' });
}

export const CreateHoliday = (subject) => {
  return fetchApi('/holidays', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const UpdateHoliday = (id, subject) => {
  return fetchApi(`/holidays/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const DeleteHoliday = (id) => {
  return fetchApi(`/holidays/${id}`, { method: 'DELETE' })
}